import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {MetadataStructure, MetadataStructureListResult} from '../../model/filter/stateListResult.model';
import {FilterService} from '../../services/filter/filter.service';
import {FormBuilder, FormGroup, FormControl} from '@angular/forms';
import {ConfigurationService} from '../../services/configuration/configuration.service';
import {GroupingConfiguration} from '../../model/configuration/groupingConfiguration.model';
import {ToastrService} from 'ngx-toastr';
import {GroupingConfigurationResult} from '../../model/configuration/groupingConfigurationResult';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {GenericModalService} from '../../services/utils/generic-modal.service';


@Component({
  selector: 'app-config-grouping',
  templateUrl: './config.grouping.component.html',
  styleUrls: ['./config.grouping.component.css']
})

export class ConfigGroupingComponent implements OnInit {
  metadataStructureList: Array<any> = [];
  groupingConfigurationList: any;
  selectedGroupingConfiguration: GroupingConfiguration;
  domainValue: string;
  isValidGroupingName: boolean;
  isValidDomain: boolean;
  isValidMetadataName: boolean;
  isSaving: boolean;
  successfullySaved: boolean;
  isConfigLoading: boolean;

  constructor(private modalService: BsModalService, private filterService: FilterService,
              private configurationService: ConfigurationService, private fb: FormBuilder,
              private toastr: ToastrService, public genericModalService: GenericModalService,
              public bsModalRef: BsModalRef) {
    this.isConfigLoading = false;
    this.listGroupingConfigurations();
    this.selectedGroupingConfiguration = new GroupingConfiguration();
  }

  metadataStructureCtrl = new FormControl();
  formMetadataStructure = new FormGroup({
    metadataList: this.metadataStructureCtrl
  });

  listGroupingConfigurations(): void {
    this.isConfigLoading = true;
    this.groupingConfigurationList = [];

    this.configurationService.listGroupingConfigurations().subscribe((resp: GroupingConfigurationResult) => {
      if (resp.result) {
        this.groupingConfigurationList = resp.result;
      } else if (resp.error) {
        this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
      }
      this.isConfigLoading = false;
    });
  }


  ngOnInit() {
    this.modalService.onShow.subscribe((reason: string) => {
      this.getMetadataStructures();
    });
  }

  getMetadataStructures(): void {
      this.filterService.getMetadataStructures().subscribe((resp: MetadataStructureListResult) => {
        if (resp.result) {
          this.metadataStructureList = resp.result;
        } else if (resp.error) {
          this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
        }
      });
  }

  onClickNew(staticModel: TemplateRef<any>) {
    this.configEditingModal();
    this.selectedGroupingConfiguration = new GroupingConfiguration();
    this.bsModalRef = this.genericModalService
        .showObjModalWithTemplate(staticModel, {});
  }

  onClickEdit(content, staticModel: TemplateRef<any>) {
    this.selectedGroupingConfiguration = Object.assign({}, content);
    this.configEditingModal();
    this.bsModalRef = this.genericModalService
        .showObjModalWithTemplate(staticModel, {});
  }

  onClickDelete(content: GroupingConfiguration) {
    this.selectedGroupingConfiguration = Object.assign({}, content);
  }

  onClickConfirmDelete() {
    this.configurationService.deleteGroupingConfiguration(this.selectedGroupingConfiguration.id).subscribe((resp: any) => {
      this.toastr.success('Agrupamento ' + this.selectedGroupingConfiguration.groupingName +
        ' excluído com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
      this.listGroupingConfigurations();
    });
  }

  configEditingModal() {
    this.getMetadataStructures();
    this.isValidDomain = true;
    this.isValidGroupingName = true;
    this.isValidMetadataName = true;
    this.successfullySaved = false;
    this.domainValue = undefined;
    this.isSaving = false;
  }

  onClickAddNewDomainValue(textContent: string) {
    if (this.selectedGroupingConfiguration.domain == undefined) {
      this.selectedGroupingConfiguration.domain = [];
    }
    if (this.selectedGroupingConfiguration.domain.indexOf(textContent) > -1) {
      return;
    }
    this.selectedGroupingConfiguration.domain.push(textContent);
    this.domainValue = undefined;
    this.validateDomain();
  }

  addDomainButtonIsDisabled() {
    return this.domainValue == undefined || this.domainValue.trim() == '';
  }

  onClickDeleteDomainValue(content: string) {
    const index: number = this.selectedGroupingConfiguration.domain.indexOf(content, 0);
    if (index > -1) {
      this.selectedGroupingConfiguration.domain.splice(index, 1);
    }
    this.validateDomain();
  }

  onChangeGroupingName() {
    this.validateGroupingName();
  }

  typeaheadNoResults(noResults: boolean) {
    this.isValidMetadataName = !noResults;
  }

  onClickSaveGroupingConfig() {

    if (!this.isValidForm()) {
      this.toastr.error('Não é possível salvar pois existe(m) campo(s) inválido(s).', 'Erro', {positionClass: 'toast-top-center'});
      return;
    }

    this.isSaving = true;
    this.configurationService.saveGroupingConfiguration(this.selectedGroupingConfiguration)
      .subscribe(
      (resp: any) => {
          if (resp.result) {
            this.successfullySaved = true;
            this.toastr.success('Agrupamento salvo com sucesso!', 'Sucesso', {positionClass: 'toast-top-center'});
            this.isSaving = false;
            this.onCloseModal();
            this.listGroupingConfigurations();
          } else if (resp.error) {
            this.successfullySaved = false;
            this.isSaving = false;
            this.toastr.error(resp.errorMessage, 'Erro', {positionClass: 'toast-top-center'});
          }
          this.isSaving = false;
        }
      );
  }

  isValidForm() {
    this.validateGroupingName();
    this.validateDomain();
    this.validateMetadataName();

    return this.isValidDomain && this.isValidGroupingName && this.isValidMetadataName;
  }

  validateGroupingName() {
    return this.isValidGroupingName = this.selectedGroupingConfiguration.groupingName != undefined &&
      this.selectedGroupingConfiguration.groupingName.trim() != '';
  }

  validateDomain() {
    if (this.selectedGroupingConfiguration.domain == undefined) {
      return this.isValidDomain = false;
    }
    return this.isValidDomain = this.selectedGroupingConfiguration.domain.length > 0;
  }

  validateMetadataName() {
    return this.isValidMetadataName = this.selectedGroupingConfiguration.metadataStructure != undefined;
  }

  onSelectMetadata(event: TypeaheadMatch) {
    this.selectedGroupingConfiguration.metadataStructure = event.item;
  }

  onCleanMetadataStructure() {
    this.selectedGroupingConfiguration.metadataStructure = new MetadataStructure();
  }

  onCloseModal() {
    this.bsModalRef.hide();
  }

}
